import type { ProviderGetImage } from "@nuxt/image";

export const getImage: ProviderGetImage = (src) => {
	if (src.startsWith("/ecommerce-binaries")) {
		return {
			url: src,
			isStatic: false,
		};
	}

	return null;
};
